import PropTypes from 'prop-types'

const NotLoggedLayout = ({ children }) => <>{children}</>

NotLoggedLayout.propTypes = {
  children: PropTypes.node,
}

export default NotLoggedLayout
